import { AccountingClass } from "./accounting-class";
import { GeneralLedgerDetail } from "./general-ledger-detail";
import { SystemField } from "./system-field";

export class ChartOfAccount extends SystemField{
     code?:string;
     accounting_name?:string;
     accounting_class_id?:string;
     is_active?:number;
     is_cash_acc?:number;
     name?:string;
 
    //relationship
    gl_details?:GeneralLedgerDetail[];
    accounting_class?:AccountingClass;
}
